module.exports = __webpack_public_path__ + "static/media/game_page.b4ac5567.jpg";